import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Flap from '../flap/Flap';
import Product from './Product';
import ProductTileMobile from './ProductTileMobile';

import { configuratorType } from '../../i18n.js';

class ProductGroupsMobile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      productGroups: [],
    };
  }

  componentDidMount() {
    const { data } = this.props;

    if (data) {
      this.initState(data);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { data } = nextProps;

    // TODO this only compares object equality, but not a deep comparison of nested values
    if (data !== this.props.data) {
      // TODO Shouldn't here used the nextProps.data as parameter?
      this.initState(this.props.data);
    }
  }
  
     onClickDownload(productGroup) {
      const { onClickDownload } = this.props;
  
      if (typeof onClickDownload === 'function') {
        onClickDownload([
          ...productGroup.products.map(p => p.id), ...productGroup.bundle.map(p => p.id)
        ]);
      }
    }

  chooseGroup(currentGroup) {
    this.setState({
      productGroups: this.state.productGroups
        .map(group => ({ ...group, open: group.id == currentGroup.id ? !group.open : group.open })),
    });
  }

  initState(data) {
    this.setState({ productGroups: data.map((group, i) => ({ ...group, open: i === 0, id: i })) });
  }

  render() {
    const { productGroups } = this.state;

    if (!productGroups || productGroups.length === 0) {
      return null;
    }
    return (
      <div className="product">
        <div className="flap-group">
          {productGroups.map((productGroup, i) => (
            <Flap key={i} index={i} headline={`Proposal ${i + 1}`} resetHeight={true} open={productGroup.open} onChange={() => this.chooseGroup(productGroup)}>
              <div>
                <div className="container">
                  {productGroup.products.map((product, j) => (
                    <Product key={j} data={product} />
                  ))}
                </div>
                {configuratorType === 'shower' &&
                <div className="container">
                  <a className="btn btn-block btn-primary button button--download " href="javascript:void(0);" onClick={() => this.onClickDownload(productGroup)}>
                    <FormattedMessage id="results.product.button.downloadPDF" />
                  </a>
                </div>
                }
                {productGroup.bundle.length > 0 &&
                    <div className="separator">
                      <h3 className="text-uppercase headline headline--center headline--h3 headline--result">
                        <span className="headline__inner"><FormattedMessage id="results.bundle.title" /></span>
                      </h3>
                </div>
                 }
                <div className="container">
                  {productGroup.bundle.map((product, j) => (
                    <ProductTileMobile key={j} data={product} />
                  ))}
                </div>
              </div>
            </Flap>
          ))}
        </div>
      </div>
    );
  }
}

ProductGroupsMobile.propTypes = {
  data: PropTypes.array.isRequired,
  onClickDownload: PropTypes.func,
};

export default ProductGroupsMobile;


// WEBPACK FOOTER //
// ./src/components/product/ProductGroupsMobile.js